<template>
  <div>
    <div class="text-right">
      <button class="btn btn-outline-success btn-xs" @click="editUser({is_active: 1, options: {comment: null}})">новый
        владелец
      </button>
    </div>
    <table class="table table-sm mt-0 table-hover">
      <thead>
      <tr>
        <th></th>
        <th>Фамилия</th>
        <th>Полное имя</th>
        <th>Доступ</th>
        <th>комментарий</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(u, i) in users" v-if="u.is_active" :key="u.id">
        <td>{{ i + 1 }}</td>
        <td>({{ u.id }}) {{ u.short_name }}</td>
        <td>{{ u.full_name }}</td>
        <td>
          <button v-if="!showAccess[u.id]" @click="showUserAccess(u.id)" class="btn btn-default btn-xs">показать
          </button>
          <p v-if="showAccess[u.id]">{{ u.banking_login }}:{{ u.banking_password }}</p>
        </td>
        <td>{{ u.options && u.options.comment }}</td>
        <td>
          <button @click="editUser(u)" class="btn btn-outline-info btn-xs">редактировать</button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  props: ['users', 'updateUser'],
  data() {
    return {
      localUsers: [],
      loading: false,
      showAccess: {},
    }
  },
  methods: {
    updateRecords(user) {
      if (this.updateUser) {
        this.updateUser(user);
      }
    },
    editUser(user) {
      this.$store.dispatch('platform/setGlobalDrawerData', {
        data: {type: 'editCreditCardUser', user: user},
        callBackAction: (r) => this.updateRecords(r)
      });
    },
    showUserAccess(id) {
      this.showAccess[id] = true;
      this.showAccess = {...this.showAccess};
    }
  }
}

</script>
